import toast from 'react-hot-toast';
import { extractApiError } from './index';

// Settles the upload toast from the mutation, not the page: callbacks passed to `mutate()` die with
// the component, so leaving mid-upload left the toast hanging at 100% forever (BUG 3792).
// Call sites pass `toastId` / `uploadSuccessMessage` / `uploadErrorMessage` in the mutation variables.

// A toast update MERGES, so the loader's spinner would outlive it; `undefined` restores the type icon.
const CLEAR_LOADING_ICON = { icon: undefined };

export const withUploadToast = (queryClient, options = {}) => ({
  ...options,
  onSuccess: (data, variables, context) => {
    if (variables?.toastId) {
      toast.success(variables.uploadSuccessMessage || 'Upload complete', {
        id: variables.toastId,
        ...CLEAR_LOADING_ICON
      });
    }
    // Files only — refetching fund mappings here would undo a just-made pairing (see SourceFilesV2).
    const { periodId } = variables ?? {};
    queryClient?.invalidateQueries(
      periodId ? ['GET_PERIOD_FILES', periodId] : ['GET_PERIOD_FILES']
    );
    options.onSuccess?.(data, variables, context);
  },
  onError: (error, variables, context) => {
    if (variables?.toastId) {
      toast.error(
        extractApiError(error, variables.uploadErrorMessage || 'Failed to upload files.'),
        {
          id: variables.toastId,
          ...CLEAR_LOADING_ICON
        }
      );
    }
    options.onError?.(error, variables, context);
  }
});
